import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
  {
    path: '/agent',
    name: 'agent',
    meta: { title: '代理商' },
    redirect: '/agent/index',
    component: Main,
    children: [{
      path: '/agent/index',
      name: 'lists',
      meta: {
        title: '代理商',
        parentPath: '/agent',
        icon: 'el-icon-s-custom',
        permission: ['view']
      },
      component: Blank,
      redirect: '/agent/index',
      children: [
        {
          path: '/agent/index',
          name: 'agent_index',
          meta: {
            title: '代理商列表',
            parentPath: '/agent',
            permission: ['view']
          },
          component: () => import('@/views/agent/index.vue')
        },
      ]
    },]
  }
]

export default routes
